<template v-if="this.user.loggedIn">
  <div class="container">
    <h1 class="text-center mb-3">Archiv</h1>
    <div v-if="message.success !== undefined">
      <div class="alert alert-success fixed-top text-center" role="alert">
        {{ message.success }}
      </div>
    </div>
    <div v-if="message.error !== undefined">
      <div class="alert alert-danger fixed-top text-center" role="alert">
        {{ message.error }}
      </div>
    </div>
    <div class="card">
      <div
        v-if="!dataArray"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div v-else>
        <div>
          <label for="searchInput" class="d-none">Suchen:</label>
          <b-form-input
            type="text"
            id="searchInput"
            placeholder="Suche..."
            v-model="searchQuery"
          ></b-form-input>
        </div>
        <table class="table table-hover m-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Stelle</th>
              <th>Abteilung</th>
              <th>Eingegangen</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr @click="createNew(item?.id)" v-for="(item, index) in filteredApplications" :key="index">
              <td>
                <span v-if="item?.firstname">{{
                  item?.firstname + " " + item?.name
                }}</span>
                <span v-else>{{ item?.email }}</span>
              </td>
              <td>{{ item?.jobOfferName }}</td>
              <td>
                {{ item?.department }}
                <template v-if="item?.trainee"
                  ><br /><b-badge>Ausbildung</b-badge></template
                >
              </td>
              <td>{{ convert(item.incoming.toDate()) }}</td>
              <td>
                <div
                  v-if="
                    item?.reply &&
                    (!item?.emails ||
                      !item?.emails.some((email) => email?.read === false))
                  "
                >
                  <font-awesome-icon :icon="['fas', 'reply']" />
                </div>
                <div
                  v-else-if="
                    item?.emails &&
                    item?.emails.some((email) => email?.read === false)
                  "
                >
                  <span class="badge badge-pill badge-danger">{{
                    item?.emails.filter((email) => email?.read === false).length
                  }}</span>
                </div>
                <div v-else>
                  <span class="badge badge-pill badge-danger">NEW</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      size="xl"
      tabindex="-1"
      role="dialog"
      v-model="formularModal"
      :title="jobOfferName"
      aria-hidden="true"
      hide-footer
    >
      <div
        v-if="personData == '' || personData == undefined"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div
        v-if="personData !== '' && personData !== undefined"
        class=""
        style="width: 100%"
      >
        <div id="printMe">
          <h4 class="printOnly">{{ jobOfferName }}</h4>
          <b-form-group label="Stelle auswählen" v-if="!jobOfferName">
            <b-form-select
              v-if="jobOptions.length > 0"
              v-model="selectedJobId"
              :options="jobOptions"
              text-field="text"
              value-field="value"
              @change="applyJobData"
              class="mb-3"
            />
          </b-form-group>
          <div>
            <p class="m-0"><b>Name</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.firstname + " " + personData?.name }}</p>
            </div>
            <div v-else>
              <b-form-input
                v-model="personData.firstname"
                placeholder="Vorname"
                class="mb-1"
              />
              <b-form-input v-model="personData.name" placeholder="Nachname" />
            </div>
            <p v-if="personData?.birthday" class="m-0"><b>Geburtstag</b></p>
            <p>{{ personData?.birthday }}</p>
            <p v-if="personData?.street" class="m-0"><b>Adresse</b></p>
            <p v-if="personData?.street" class="m-0">
              {{ personData?.street }}
            </p>
            <p v-if="personData?.town" class="m-0">
              {{ personData?.zip + " " + personData?.town }}
            </p>
            <p>{{ personData?.country }}</p>
            <p class="m-0"><b>Telefon</b></p>
            <div v-if="personData?.privacyPolicy">
              <p>{{ personData?.phonenumber }}</p>
            </div>
            <div v-else>
              <b-form-input
                v-model="personData.phonenumber"
                placeholder="Telefonnummer eingeben"
              />
            </div>
            <p v-if="personData?.email" class="mt-2"><b>E-Mail</b></p>
            <p>{{ personData?.email }}</p>
          </div>
          <div v-if="personData?.image">
            <ImageBlob :data="{ image: personData?.image }" />
          </div>
          <hr v-if="personData?.coverLetter" />
          <div v-if="personData?.privacyPolicy">
            <p><b>Anschreiben</b></p>
            <div v-html="personData?.coverLetter"></div>
          </div>
          <b-button
            variant="success"
            class="mt-2"
            @click="saveMissingFields()"
            v-if="changed"
            >Speichern</b-button
          >
          <div class="printOnly">
            <hr />
            <p class="m-0"><b>Anlagen</b></p>
            <p v-if="personData?.curriculumVitae" class="m-0">
              <small>Lebenslauf</small>
            </p>
            <div
              v-for="(item, index) in personData?.otherDocuments"
              :key="index"
            >
              <p class="m-0">
                <small>{{ item.name }} </small>
              </p>
            </div>
          </div>
        </div>
        <hr v-if="personData?.curriculumVitae" />
        <p v-if="personData?.curriculumVitae || personData?.otherDocuments">
          <b>Datein</b>
        </p>
        <ButtonBlob
          :data="{ data: personData?.curriculumVitae }"
          v-if="personData?.curriculumVitae"
        />
        <DropDownButtonBlob
          :data="personData?.otherDocuments"
          v-if="personData?.otherDocuments.length > 0"
        />
        <hr />
        <p><b>Aktionen</b></p>
        <!---->
        <b-button
          v-if="personData?.email"
          variant="outline-primary"
          @click="replyMe(personId)"
          class="m-1"
          ><font-awesome-icon :icon="['fas', 'reply']" /> Antworten</b-button
        >
        <!-- <b-button variant="outline-dark" @click="generateReport()" class="m-1"><font-awesome-icon :icon="['fas', 'print']" /> Drucken</b-button> -->
        <b-button
          variant="outline-danger"
          @click="deleteMe(personId)"
          class="m-1"
          ><font-awesome-icon :icon="['fas', 'trash']" /> Löschen</b-button
        >
        <b-button variant="outline-dark" @click="openMailToAl()" class="m-1"
          ><font-awesome-icon :icon="['fas', 'user-tie']" /> Freigabe für
          AL</b-button
        >
        <b-button
          variant="outline-secondary"
          @click="removeFromArchive(personId)"
          class="m-1"
          ><font-awesome-icon :icon="['fas', 'box-open']" /> Aus Archiv
          entfernen</b-button
        >
        <div class="mt-3" v-if="personData">
          <hr />
          <p><b>Notizen</b></p>
          <b-form-textarea
            id="notes-textarea"
            placeholder="Notizen..."
            v-model="personData.notes"
            rows="2"
            max-rows="6"
          ></b-form-textarea>
          <b-button
            variant="outline-success"
            class="mt-2"
            @click="saveNotes()"
            :disabled="!notesChanged || !personData.notes"
            >Speichern</b-button
          >
        </div>
        <div v-if="mergeEmailsAndReplies(personData).length > 0">
          <hr />
          <p><b>Nachrichten</b></p>

          <div
            class="accordion"
            role="tablist"
            v-for="(data, index) in mergeEmailsAndReplies(personData)"
            :key="index"
          >
            <!-- <pre>{{data}}</pre> -->
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  block
                  v-b-toggle="`collapse-${index}`"
                  @click="setIsRead(data)"
                  :variant="
                    data?.message ? 'outline-secondary' : 'outline-primary'
                  "
                  class="d-flex justify-content-between"
                  ><div v-if="data?.message">Ausgang</div>
                  <div v-else>
                    Eingang
                    <span v-if="data?.read === false"
                      ><span class="badge badge-pill badge-danger"
                        >1</span
                      ></span
                    >
                  </div>
                  <div>
                    {{
                      typeof data?.dateString === "string"
                        ? data.dateString
                        : data.date.toLocaleDateString("de-DE")
                    }}
                  </div>
                  <div></div
                ></b-button>
              </b-card-header>
              <b-collapse
                :id="`collapse-${index}`"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div>
                    <span v-if="data?.type === 'email'"
                      ><b>Von:</b> {{ data.from.name }}
                      {{ data.from.address }}</span
                    ><br />
                    <span v-if="data?.type === 'email'"
                      ><b>Datum:</b>
                      {{
                        data.date
                          .toLocaleDateString("de-DE", {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                          .replace(",", " um")
                      }}</span
                    ><br />
                    <span v-if="data?.type === 'email'"
                      ><b>An:</b> {{ data.to[0].emailAddress.address }}</span
                    ><br />
                    <span v-if="data?.type === 'email'"
                      ><b>Betreff:</b> {{ data.subject }}</span
                    ><br />
                  </div>

                  <b-card-text
                    v-html="data?.message || data.body"
                  ></b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      tabindex="-1"
      role="dialog"
      v-model="answerModal"
      aria-hidden="true"
      hide-footer
    >
      <div
        v-if="personData == '' || personData == undefined"
        class="d-flex justify-content-center p-3"
        style="width: 100%"
      >
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <div
        v-if="personData !== '' && personData !== undefined"
        class=""
        style="width: 100%"
      >
        <p>Flensburg, {{ date }}</p>
        <p><b>Ihre Bewerbung</b></p>
        <p>Hallo {{ personData?.firstname }},</p>

        <div>
          <b-form-select
            v-model="selected"
            :options="sortedTemplates"
          ></b-form-select>
          <b-form-textarea
            id="textarea"
            placeholder="Schreibe einen Antworttext..."
            v-model="selected"
            rows="2"
            max-rows="6"
          ></b-form-textarea>
        </div>
        <br />
        <p>Mit freundlichen Grüßen</p>
        <p>{{ this.user.data.displayName }}</p>
        <hr />
        <b-button
          variant="outline-primary"
          :disabled="absendenButton"
          @click="sendAnswer()"
          class="m-1"
          ><font-awesome-icon :icon="['fas', 'paper-plane']" />
          <span v-if="!loading"> Absenden </span>
          <span v-if="loading">
            <b-spinner small label="Senden..." variant="primary"></b-spinner>
          </span>
        </b-button>
        <b-button
          variant="outline-warning"
          class="m-1"
          @click="openDelayedModal"
        >
          <font-awesome-icon :icon="['fas', 'clock']" /> Später senden
        </b-button>
      </div>
    </b-modal>
    <b-modal
      v-model="delayedModal"
      title="Verzögerten Versand planen"
      hide-footer
    >
      <div>
        <b-form-group label="Anzahl der Tage bis zum Versand:">
          <b-form-input
            type="number"
            v-model="daysDelay"
            min="0"
          ></b-form-input>
        </b-form-group>
        <b-button variant="primary" @click="sendDelayedAnswer">
          <span v-if="!loading"> E-Mail planen </span>
          <span v-if="loading">
            <b-spinner small label="Planen..." variant="primary"></b-spinner>
          </span>
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="mailToAl"
      title="Freigabe für Abteilungsleiter"
      hide-footer
    >
      <div>
        <b-form-group label="E-Mail des Abteilungsleiters:">
          <b-form-input type="email" v-model="mailOfAL" min="0"></b-form-input>
        </b-form-group>
        <b-button variant="primary" @click="sendMailToAL">
          <span v-if="!loading"> Freigabe senden </span>
          <span v-if="loading">
            <b-spinner small label="Senden..." variant="primary"></b-spinner>
          </span>
        </b-button>
      </div>
    </b-modal>
    <!-- <CheckUserName/> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { functions, firestore } from "../plugins/firebase";
import {
  query,
  collection,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  updateDoc,
  where,
  orderBy,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import moment from "moment";
import ImageBlob from "./ImageBlob";
import ButtonBlob from "./ButtonBlob";
import DropDownButtonBlob from "./DropDownButtonBlob";

export default {
  name: "Applications",
  computed: {
    ...mapGetters({
      user: "user",
    }),
    filteredApplications() {
      // Convert object to array and include keys as 'id' property
      const arrayData = Array.isArray(this.dataArray)
        ? this.dataArray
        : Object.entries(this.dataArray || {}).map(([key, value]) => ({
            ...value,
            id: key,
          }));
      if (!this.searchQuery) {
        return arrayData;
      }
      const query = this.searchQuery.toLowerCase();
      return arrayData.filter((app) => {
        const fullName = `${app.firstname} ${app.name}`.toLowerCase();
        const jobOfferName = app.jobOfferName
          ? app.jobOfferName.toLowerCase()
          : "";
        return fullName.includes(query) || jobOfferName.includes(query);
      });
    },
    sortedTemplates() {
      const templates = [...this.textTamplates];
      const firstOption = templates.find((t) => t.value === null);
      const otherOptions = templates
        .filter((t) => t.value !== null)
        .sort((a, b) => a.text.localeCompare(b.text));
      return firstOption ? [firstOption, ...otherOptions] : otherOptions;
    },
  },
  components: {
    ImageBlob,
    ButtonBlob,
    DropDownButtonBlob,
  },
  watch: {
    personData: {
      handler(newD) {
        // console.log('personData changed', newD.firstname, this.personDataOriginal.firstname);
        if (
          newD.firstname !== this.personDataOriginal.firstname ||
          newD.name !== this.personDataOriginal.name ||
          newD.phonenumber !== this.personDataOriginal.phonenumber
        )
          this.changed = true;
        if (newD.notes !== this.personDataOriginal.notes)
          this.notesChanged = true;
      },
      deep: true,
    },
  },
  data() {
    return {
      mailOfAL: "",
      mailToAl: false,
      changed: false,
      dataArray: undefined,
      message: {
        success: undefined,
        error: undefined,
      },
      formularModal: false,
      answerModal: false,
      personData: undefined,
      personDataOriginal: undefined,
      jobOfferName: undefined,
      date: moment(new Date()).format("DD.MM.YYYY"),
      personId: undefined,
      selected: undefined,
      curriculumVitaeURL: undefined,
      textTamplates: [{ text: "Wähle einen Antworttext...", value: null }],
      absendenButton: false,
      selectedJob: null,
      selectedJobId: null,
      jobOptions: [],
      delayedModal: false,
      daysDelay: 0,
      loading: false,
      searchQuery: "",
      notesChanged: false,
    };
  },
  methods: {
    applyJobData() {
      this.changed = true;
      const selected = this.jobOptions.find(
        (j) => j.value === this.selectedJobId,
      );
      if (selected && selected.full) {
        const job = selected.full;
        this.personData.jobOfferName = job.jobOfferName || "";
        this.personData.department = job.department || "";
        this.personData.workingStart = job.workingStart || "";
        this.personData.workingTime = job.workingTime || "";
        this.personData.type = job.type || "";
        this.personData.limited = job.limited || "";
        this.changed = true;
      }
      this.selectedJob = selected;
    },
    async saveMissingFields() {
      if (this.selectedJob) {
        this.personData.jobOfferName = this.selectedJob.value.job;
        this.personData.department = this.selectedJob.value.department;
      }

      await updateDoc(
        doc(firestore, "application", this.personId),
        this.personData,
      )
        .then(() => {
          this.message.success = "Daten wurden ergänzt.";
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Fehler beim Speichern: " + error;
          setTimeout(this.resetMessage, 3000);
        });
      this.changed = false;
    },
    async loadData() {
      this.loadResponses();
      const q = await query(
        collection(firestore, "application"),
        orderBy("incoming"),
        where("archive", "==", true),
      );
      const querySnapshot = await getDocs(q);
      const tempData = {};
      querySnapshot.forEach((doc) => {
        tempData[doc.id] = doc.data();
      });

      this.dataArray = tempData;
    },
    async loadJobOffers() {
      const q = await query(collection(firestore, "jobOffers"));
      const querySnapshot = await getDocs(q);
      this.jobOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.jobOfferName,
          value: {
            job: data.jobOfferName,
            department: data.department,
          },
        };
      });
    },
    async sendMailToAL() {
      const mail = this.mailOfAL;
      if (mail != undefined || mail != null || mail != "") {
        this.loading = true;
        const sendMailToAl = httpsCallable(functions, "sendMailToAl");
        await sendMailToAl({ mail: mail, applicationId: this.personId })
          .then(() => {
            this.message.success =
              "Die E-Mail wurde erfolgreich an den Abteilungsleiter gesendet.";
            this.mailToAl = false;
            this.mailOfAL = "";
            setTimeout(this.resetMessage, 3000);
          })
          .catch((error) => {
            this.message.error = "Es ist ein Fehler aufgetreten.<br>" + error;
            setTimeout(this.resetMessage, 3000);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    async loadResponses() {
      const q = await query(collection(firestore, "responseSelection"));
      const querySnapshot = await getDocs(q);
      const templateOptions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          text: data.title,
          value: data.text,
        };
      });
      this.textTamplates = [
        { text: "Wähle einen Antworttext...", value: null },
        ...templateOptions,
      ];
    },
    createNew(id) {
      this.personId = id;
      this.personData = this.filteredApplications.find(
        (app) => app.id === this.personId,
      );
      this.personDataOriginal = JSON.parse(
        JSON.stringify(this.dataArray[this.personId]),
      );
      this.formularModal = !this.formularModal;
      this.jobOfferName = this.personData?.jobOfferName;
      this.curriculumVitaeURL = undefined;
    },
    correctSalutaion(salutation) {
      if (salutation === "Herr" || salutation === "Mr") {
        return "geehrter Herr";
      } else {
        return "geehrte Frau";
      }
    },
    salutation(salutation) {
      if (salutation === "Mr") {
        return "Herr";
      } else if (salutation === "Mrs") {
        return "Frau";
      } else {
        return salutation;
      }
    },
    deleteMe(id) {
      let index = id;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          `Bist du sicher, dass du die Bewerbung von ${this.dataArray[index].firstname} Löschen möchtest?`,
          {
            title: "Bitte bestätigen",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Löschen",
            cancelTitle: "Behalten",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            this.applicationModal = false;
            deleteDoc(doc(firestore, "/application", `${id}`))
              .then(() => {
                setTimeout(this.resetMessage, 3000);
                this.loadData();
                this.message.success = "Die Daten wurden erfolgreich gelöscht.";
                this.formularModal = null;
              })
              .catch((error) => {
                console.log(error);
                this.message.error =
                  "Es ist ein Fehler aufgetreten.<br>" + error;
                setTimeout(this.resetMessage, 3000);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    replyMe() {
      this.answerModal = !this.answerModal;
    },
    archivateMe(id) {
      let data = this.personData;
      data.archive = true;
      data.archiveDate = new Date();

      updateDoc(doc(firestore, "application", id), data)
        .then(() => {
          this.message.success = "Die Daten wurden erfolgreich gespeichert.";
          this.formularModal = null;
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten.<br>" + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    openDelayedModal() {
      this.delayedModal = true;
    },
    openMailToAl() {
      this.mailToAl = true;
    },
    async sendDelayedAnswer() {
      if (!this.selected || !this.personData?.email) {
        this.message.error = "Bitte E-Mail-Text auswählen oder schreiben.";
        setTimeout(this.resetMessage, 3000);
        return;
      }

      const anschreiben =
        "<p><b>Deine Bewerbung</b></p>" +
        "<p>Hallo " +
        this.personData?.firstname +
        ",</p>";
      const verabschiedung =
        "<br><p> Mit freundlichen Grüßen</p>" + this.user.data.displayName;

      const anschreibenPlain =
        "Deine Bewerbung\n\n" + "Hallo " + this.personData?.firstname + ",\n\n";
      const verabschiedungPlain =
        "\n\nMit freundlichen Grüßen\n" + this.user.data.displayName;

      const mailData = {
        to: this.personData?.email,
        subject: "Deine Bewerbung - ComLine GmbH.",
        html: anschreiben + this.selected + verabschiedung,
        text: anschreibenPlain + this.selected + verabschiedungPlain,
        daysDelay: this.daysDelay,
      };

      try {
        this.loading = true;
        const planMail = httpsCallable(functions, "planMail");
        await planMail(mailData);
        this.message.success = `E-Mail wurde für den Versand in ${this.daysDelay} Tag(en) geplant.`;
        this.delayedModal = false;
        this.answerModal = false;
        this.selected = "";
        this.answered(this.personId);
        this.replyed(this.personId, mailData.html);
      } catch (error) {
        this.message.error = "Planung fehlgeschlagen: " + error.message;
      } finally {
        this.loading = false;
      }

      setTimeout(this.resetMessage, 3000);
    },
    setIsRead(data) {
      if (data.type === "email") {
        // Erst das Dokument holen
        getDoc(doc(firestore, "application", this.personId))
          .then((docSnap) => {
            if (docSnap.exists()) {
              const docData = docSnap.data();

              // Index der gewünschten Email-ID in data.in finden
              const emailIndex = data.id;

              if (emailIndex !== -1) {
                // Read-Status für das spezifische Email-Element setzen
                const updatedIn = [...docData.emails];
                updatedIn[emailIndex].read = true;

                // Nur das 'in' Array updaten
                updateDoc(doc(firestore, "application", this.personId), {
                  emails: updatedIn,
                })
                  .then(() => {
                    console.log("setIsRead", updatedIn[emailIndex]);
                  })
                  .catch((error) => {
                    console.warn(error);
                  });
              }
            }
          })
          .catch((error) => {
            console.warn("Error getting document:", error);
          });
      }
    },
    resetMessage() {
      this.message.success = undefined;
      this.message.error = undefined;
    },
    parseGermanDate(date) {
      return date.toDate();
    },
    // Hilfsfunktion um Timestamp-Objekte zu konvertieren
    convertTimestamp(timestamp) {
      if (timestamp && timestamp.seconds) {
        return new Date(timestamp.seconds * 1000);
      }
      return new Date(timestamp);
    },
    mergeEmailsAndReplies(applicationData, options = {}) {
      const { sortOrder = "asc", includeHtmlContent = true } = options;
      const mergedItems = [];
      const emails = applicationData.emails || [];
      const replies = applicationData.replyed || [];

      // 1) Original-Emails
      emails.forEach((email, idx) => {
        const dt = this.convertTimestamp(
          email.sentDateTime || email.createdDateTime,
        );
        mergedItems.push({
          type: "email",
          id: idx,
          date: dt,
          dateString: dt.toLocaleDateString("de-DE"),
          subject: email.subject,
          from: email.from?.emailAddress || email.sender?.emailAddress,
          to: email.toRecipients,
          body: includeHtmlContent ? email.body?.content : email.bodyPreview,
          read: email.read,
        });
      });

      // 2) Replies (geplant oder sofort)
      // mergeEmailsAndReplies(applicationData, options = {})
      replies.forEach((reply, idx) => {
        let dt = null;

        if (
          typeof reply.sendAt === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.sendAt)
        ) {
          dt = new Date(reply.sendAt.split(".").reverse().join("-"));
        } else if (reply.sendAt instanceof Date) {
          dt = reply.sendAt;
        } else if (reply.sendAt?.toDate) {
          dt = reply.sendAt.toDate();
        }

        // 🔧 HIER NEU: Fallback auf "date" (dein altes Textdatum)
        if (
          !dt &&
          typeof reply.date === "string" &&
          /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(reply.date)
        ) {
          dt = new Date(reply.date.split(".").reverse().join("-"));
        }

        if (!dt || isNaN(dt.getTime())) {
          dt = new Date(); // letzter Fallback
        }

        // Für die Anzeige
        const ds = dt.toLocaleDateString("de-DE");

        mergedItems.push({
          type: "reply",
          id: idx,
          date: dt,
          dateString: ds,
          subject: `Re: ${applicationData.jobOfferName || "Bewerbung"}`,
          message: reply.message,
        });
      });

      // 3) Sortierung
      mergedItems.sort((a, b) => {
        return sortOrder === "desc" ? b.date - a.date : a.date - b.date;
      });

      return mergedItems;
    },
    sendAnswer() {
      if (
        this.selected !== undefined &&
        this.selected !== null &&
        this.selected !== ""
      ) {
        this.absendenButton = true;
        const futureDate = moment()
          .add(this.daysDelay, "days")
          .format("DD.MM.YYYY");
        const anschreiben =
          "<p>Flensburg, " +
          futureDate +
          "</p>" +
          "<p><b>Deine Bewerbung</b></p>" +
          "<p>Hallo " +
          this.personData?.firstname +
          ",</p>";

        const verabschiedung =
          "<br><p> Mit freundlichen Grüßen</p>" + this.user.data.displayName;

        const anschreibenPlain =
          "Flensburg, " +
          futureDate +
          "\n" +
          "Deine Bewerbung\n\n" +
          "Hallo " +
          this.personData?.firstname +
          ",\n\n";
        const verabschiedungPlain =
          "\n\nMit freundlichen Grüßen\n" + this.user.data.displayName;

        const mailData = {
          mail: this.personData?.email,
          subject: "Deine Bewerbung - ComLine GmbH.",
          message: anschreiben + this.selected + verabschiedung,
          text: anschreibenPlain + this.selected + verabschiedungPlain,
          html:
            anschreiben +
            this.selected.replace(/(?:\r\n|\r|\n)/g, "<br>") +
            verabschiedung,
          user: this.user.data.email,
        };

        this.loading = true;

        const sendMail = httpsCallable(functions, "sendMail");
        sendMail(mailData)
          .then(() => {
            this.message.success = "Die E-Mail wurde erfolgreich versendet.";
            this.answerModal = false;
            this.selected = "";
            this.answered(this.personId);
            this.replyed(this.personId, mailData.html);
            this.absendenButton = false;
            setTimeout(this.resetMessage, 1000);
            return null;
          })
          .catch((error) => {
            this.absendenButton = false;
            this.message.error = "Die E-Mail konnte nicht versendet werden.";
            setTimeout(this.resetMessage, 1000);
            console.warn(error);
            return null;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.absendenButton = false;
        this.message.error =
          "Bitte Wählen Sie einen Text aus oder Schreiben Sie einen Text.";
        setTimeout(this.resetMessage, 3000);
      }
    },
    generateReport() {
      this.$htmlToPaper("printMe");
    },
    answered(id) {
      let data = this.personData;
      data.reply = true;
      updateDoc(doc(firestore, "application", id), data);
    },
    replyed(id, data) {
      const now = new Date();
      const sendAt =
        this.daysDelay > 0
          ? moment().add(this.daysDelay, "days").toDate()
          : now;

      const replyEntry = {
        createdAt: now,
        sendAt: sendAt,
        message: data,
      };

      let allData = this.personData;
      if (Array.isArray(allData?.replyed)) {
        allData.replyed.push(replyEntry);
      } else {
        allData.replyed = [replyEntry];
      }

      updateDoc(doc(firestore, "application", id), allData);
    },
    convert(data) {
      var date = new Date(data);
      return moment(date).format("DD.MM.YYYY");
    },
    async saveNotes() {
      updateDoc(doc(firestore, "application", this.personId), {
        notes: this.personData.notes,
      })
        .then(() => {
          this.message.success = "Die Notizen wurden erfolgreich gespeichert.";
          this.notesChanged = false;
          setTimeout(this.resetMessage, 3000);
        })
        .catch((error) => {
          this.message.error = "Es ist ein Fehler aufgetreten. " + error;
          setTimeout(this.resetMessage, 3000);
        });
    },
    removeFromArchive() {
      this.$bvModal
        .msgBoxConfirm(
          `Bist du sicher, dass du die Bewerbung von ${this.personData?.firstname} aus dem Archiv entfernen möchtest?`,
          {
            title: "Bitte bestätigen",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Entfernen",
            cancelTitle: "Abbrechen",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            let data = this.personData;
            data.archive = false;
            data.archiveDate = null;

            updateDoc(doc(firestore, "application", this.personId), data)
              .then(() => {
                this.message.success =
                  "Die Bewerbung wurde erfolgreich aus dem Archiv entfernt.";
                this.formularModal = null;
                this.loadData();
                setTimeout(this.resetMessage, 3000);
              })
              .catch((error) => {
                this.message.error = "Es ist ein Fehler aufgetreten: " + error;
                setTimeout(this.resetMessage, 3000);
              });
          }
        });
    },
  },
  mounted() {
    this.loadData();
    this.loadJobOffers();
  },
};
</script>

<style scoped>
tr {
  cursor: pointer;
}
#personImage {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 5px;
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  margin: 16px;
  width: 240px;
}
.printOnly {
  display: none;
}
.alert {
  z-index: 999999999;
}
</style>
<style>
#mail-editor-reference-message-container {
  display: none !important;
}
</style>
